import {
  isValidPhoneNumber,
  parsePhoneNumberFromString,
} from 'libphonenumber-js';

export const validatePhoneNumber = (phoneNumber, country = null) => {
  if (!phoneNumber || typeof phoneNumber !== 'string') {
    return false;
  }

  const cleanedPhone = phoneNumber.trim();

  if (!cleanedPhone) {
    return false;
  }

  if (country) {
    return isValidPhoneNumber(cleanedPhone, country);
  }

  return isValidPhoneNumber(cleanedPhone);
};

export const parsePhoneNumberInfo = (phoneNumber, country = null) => {
  if (!phoneNumber || typeof phoneNumber !== 'string') {
    return null;
  }

  const cleanedPhone = phoneNumber.trim();
  if (!cleanedPhone) {
    return null;
  }
  return parsePhoneNumberFromString(cleanedPhone, country || undefined);
};
